import { isTruthy } from "./isTruthy";
import { locales } from "./localization";
export var validateBreadcrumbs = function validateBreadcrumbs(breadcrumbs) {
  // Menu link set as '#' throws, so wrap in try catch.
  try {
    var breadcrumbLinks = (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.filter(isTruthy).map(function (breadcrumb) {
      var _breadcrumb_url;
      return {
        text: breadcrumb.text,
        url: breadcrumb === null || breadcrumb === void 0 ? void 0 : (_breadcrumb_url = breadcrumb.url) === null || _breadcrumb_url === void 0 ? void 0 : _breadcrumb_url.replace(/https?:\/\/[^/]+/i, "")
      };
    })) || [];
    // if we find a link in the form of [locale]/node it means that the entity has no breadcrumbs
    // or it's not linked to any menu item, so we return an empty array
    var hasInvalidBreadcrumbs = breadcrumbLinks.find(function (breadcrumb) {
      var _breadcrumb_url;
      return (_breadcrumb_url = breadcrumb.url) === null || _breadcrumb_url === void 0 ? void 0 : _breadcrumb_url.match(new RegExp("^/(".concat(Object.keys(locales).join("|"), ")/node")));
    });
    return hasInvalidBreadcrumbs ? [] : breadcrumbLinks;
  } catch (exception) {
    console.error(exception);
  }
  return [];
};